import { getDayStartAndEndHours } from 'domains/shifts/components/components/weekly-staffing/utils/getDayStartAndEndHours'
import { type StartAndEndDeliveryHour } from 'domains/shifts/components/components/weekly-staffing/utils/types'
import { type DeliveryHours } from 'domains/shifts/components/types'

/**
 * Returns the earliest start hour and latest end hour in the week,
 * which represents the full range of weekly opening hours for a store.
 */
export const getHoursLimitsForWeek: (
  regularHours: DeliveryHours[]
) => StartAndEndDeliveryHour = regularHours =>
  regularHours.reduce(
    (limits, day) => {
      const { start, end } = getDayStartAndEndHours(day)

      return {
        start: !limits.start || start < limits.start ? start : limits.start,
        end: !limits.end || end > limits.end ? end : limits.end,
      }
    },
    {
      start: undefined,
      end: undefined,
    }
  )
